import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddFamily from './components/AddFamily';
import '../../styles/products.scss';

const FamilyEdit = () => {
  const { id } = useParams();
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Modifier la Famille');
  }, [setTitle]);

  return (
    <div className="family-edit-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddFamily isEdit={true} familyId={id} />
        </Col>
      </Row>
    </div>
  );
};

export default FamilyEdit;
